// Selection eligibility only. Keep complete directories for historical names and saved assignments.
import { isOfferedForQuotes } from '../../functions-shared/catalog/catalogOffering.js'

export function isSelectableUser(user) {
  return !!user && user.status?.accountStatus !== 'suspended'
}

export function isSelectableOrganization(org) {
  return !!org && org.status?.active !== false
}

export function isSelectableProjectType(type, { includeInactive = false } = {}) {
  return (
    !!type &&
    (includeInactive || type.isActive !== false) &&
    type.isVisible !== false &&
    type.legacy !== true &&
    !type.isDeleted
  )
}

export function isSelectableFinancialProduct(product) {
  return isSelectableProjectType(product) && product.isActive === true
}

// A launch's staff-only phase (visibleToRoles): never offered on a public or marketing surface (Board bulk estimates
// included). Mirrors functions-shared/utils/selectorEligibility.js.
export function isStaffOnlyFinancialProduct(product) {
  return Array.isArray(product?.visibleToRoles) && product.visibleToRoles.length > 0
}

export function selectorExclusion(collection, record) {
  if (['users', 'publicUsers'].includes(collection) && !isSelectableUser(record)) return 'suspended'
  if (collection === 'organizations' && !isSelectableOrganization(record)) return 'suspended'
  if (
    ['workflowProjectTypes', 'financialProducts'].includes(collection) &&
    !isSelectableProjectType(record)
  )
    return 'retiredProjectType'
  // Equipment Mgmt's Active box: an inactive catalog item is not a new pick (catalogOffering.js).
  if (collection === 'costCatalog' && !isOfferedForQuotes(record)) return 'inactiveCatalogItem'
  return null
}
